  const colorLists = [
	{cen:  "red",cde:"rot"},
	{cen:"rgb(192,219,210)", cde: "matt mint"},
	{cen:  "pink",cde:"rosa"},
	{cen:"rgb(219,216,223)", cde : "creme"},
	{cen: "rgb(197,197,197)", cde: "Heather Grau"},
	{cen:  "orange",cde:"orange"},
	{cen:  "yellow",cde:"gelb"},
	{cen:  "green",cde:"grün"},
	{cen: "rgb(53,67,78)", cde: "matt blau"},
	{cen:  "blue",cde:"blau"},
	{cen:  "purple",cde:"lila"},
	{cen:  "rgb(197,197,197)",cde:"grau"},
	{cen:  "brown",cde:"braun"},
	{cen:  "biege",cde:"biege"},
	{cen:  "rgb(244,244,244)",cde:"weiß"},
	{cen:  "rgb(10,10,10)",cde:"schwarz"},
];
  		jQuery("fieldset.shadow-box-variants label").each(function(ind,eli){
			if(jQuery(eli).prev().attr("checked")){
				jQuery(eli).addClass("active");
			}
			const currentColor = jQuery(eli).text().toLowerCase().trim();
			const color = colorLists.find(function(clr){
				return currentColor.indexOf(clr.cde) > -1
			});
			jQuery(eli).click(function(e){
			jQuery(this).closest("fieldset").find(".selected-option").html(jQuery(eli).find(".current-value").text());
				setTimeout(function() {
				jQuery(eli).closest("fieldset").find("label").each(function(chkindex, checkelement){
					jQuery(checkelement).removeClass('active');
				})
				jQuery(e.currentTarget).addClass("active")
						}, 500);
				});
				if(color){
					jQuery(this).css("backgroundColor", color.cen);	
				}
		});
